document.documentElement.classList.remove('no-js');

document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('[data-menu-toggle]').forEach((button) => {
    button.addEventListener('click', () => {
      const nav = document.getElementById(button.getAttribute('aria-controls'));
      if (!nav) return;
      const open = nav.classList.toggle('is-open');
      button.setAttribute('aria-expanded', open ? 'true' : 'false');
    });
  });

  document.querySelectorAll('[data-faq-question]').forEach((button) => {
    button.addEventListener('click', () => {
      const item = button.closest('.faq-item');
      if (!item) return;
      const open = item.classList.toggle('is-open');
      button.setAttribute('aria-expanded', open ? 'true' : 'false');
    });
  });

  document.querySelectorAll('[data-variant-select]').forEach((select) => {
    const update = () => {
      const option = select.options[select.selectedIndex];
      const scope = select.closest('[data-product-scope]');
      if (!scope || !option) return;
      const price = scope.querySelector('[data-product-price]');
      const button = scope.querySelector('[data-add-to-cart]');
      if (price && option.dataset.price) price.textContent = option.dataset.price;
      if (button) {
        const available = option.dataset.available === 'true';
        button.disabled = !available;
        button.textContent = available ? (button.dataset.availableText || 'Add to cart') : (button.dataset.soldoutText || 'Sold out');
      }
    };
    select.addEventListener('change', update);
    update();
  });
});
